var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAiFileFailedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 77,
    height: 24,
    viewBox: "0 0 77 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_161753",
    "data-name": "Group 161753",
    transform: "translate(-76 -240)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_161741",
    "data-name": "Group 161741",
    transform: "translate(-0.462)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_83701",
    "data-name": "Path 83701",
    transform: "translate(76.462 240)",
    fill: "#fad9e3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 74 23.5 L 3 23.5 C 1.621500015258789 23.5 0.5 22.37849998474121 0.5 21 L 0.5 3 C 0.5 1.621500015258789 1.621500015258789 0.5 3 0.5 L 74 0.5 C 75.37850189208984 0.5 76.5 1.621500015258789 76.5 3 L 76.5 21 C 76.5 22.37849998474121 75.37850189208984 23.5 74 23.5 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 3 1 C 1.897201538085938 1 1 1.897199630737305 1 3 L 1 21 C 1 22.1028003692627 1.897201538085938 23 3 23 L 74 23 C 75.10279846191406 23 76 22.1028003692627 76 21 L 76 3 C 76 1.897199630737305 75.10279846191406 1 74 1 L 3 1 M 3 0 L 74 0 C 75.65685272216797 0 77 1.343145370483398 77 3 L 77 21 C 77 22.65685653686523 75.65685272216797 24 74 24 L 3 24 C 1.343147277832031 24 0 22.65685653686523 0 21 L 0 3 C 0 1.343145370483398 1.343147277832031 0 3 0 Z",
    stroke: "none",
    fill: "#d7959d"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_83727",
    "data-name": "Path 83727",
    d: "M9.54,12h1.053V7.931h3.861V6.982H10.594V3.862h4.134V2.9H9.54Zm9.659.169a2.767,2.767,0,0,0,2.34-1.235h.078V12h.988V5.24H21.578V6.332H21.5a2.768,2.768,0,0,0-2.379-1.261,3.309,3.309,0,0,0-3.289,3.562A3.31,3.31,0,0,0,19.2,12.169Zm.065-.923a2.361,2.361,0,0,1-2.379-2.613,2.379,2.379,0,1,1,4.732,0A2.4,2.4,0,0,1,19.264,11.246Zm6.084-7.228a.731.731,0,0,0,.754-.754.748.748,0,0,0-1.5,0A.728.728,0,0,0,25.349,4.018ZM24.816,12h1.027V5.24H24.816Zm4.576,0h.494v-.91h-.312c-.325,0-.494-.195-.494-.533V2.25H28.052v8.307A1.269,1.269,0,0,0,29.392,12Zm5.044.169a3.131,3.131,0,0,0,3.146-2.158H36.516a2.143,2.143,0,0,1-2.067,1.222,2.181,2.181,0,0,1-2.314-2.249h5.512V8.529A3.2,3.2,0,0,0,34.37,5.071,3.31,3.31,0,0,0,31.056,8.62,3.308,3.308,0,0,0,34.436,12.169Zm-2.275-4.1a2.194,2.194,0,0,1,2.21-2.067,2.085,2.085,0,0,1,2.184,2.067Zm10.153,4.1a2.767,2.767,0,0,0,2.34-1.235h.078V12h.988V2.25H44.693V6.332h-.078a2.768,2.768,0,0,0-2.379-1.261,3.309,3.309,0,0,0-3.289,3.562A3.31,3.31,0,0,0,42.313,12.169Zm.065-.923A2.361,2.361,0,0,1,40,8.633a2.379,2.379,0,1,1,4.732,0A2.4,2.4,0,0,1,42.379,11.246Z",
    transform: "translate(87.462 244)",
    fill: "#ce4c5d"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiFileFailedIcon);
export default __webpack_public_path__ + "static/media/ai-file-failed-icon.05c60f084a260334b4a6f5cbce9814f5.svg";
export { ForwardRef as ReactComponent };